import styled from "styled-components";
import { CartPaymentButton } from "../CartTotalSummary/style";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 48px;
  background-color: #f9f9f9;
  padding: 32px;
  box-sizing: border-box;
  border-radius: 10px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    gap: 32px;
    padding: 16px;
  }
`;

export const PageTitle = styled.h2`
  width: 100%;
  margin: 0;
  font-size: 36px;
  font-weight: 300;
  color: #000000;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 24px;
  }
`;

export const StepBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AddressFieldsBlock = styled(StepBlock)`
  gap: 48px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    gap: 16px;
  }
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`;

export const StepCircle = styled.div`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ee3841;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins", "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: 600;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 32px;
    height: 32px;
    font-size: 18px;
  }
`;

export const StepLabel = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: #000000;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 18px;
  }
`;

export const Hint = styled.p`
  width: 100%;
  margin: -8px 0 0;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #737377;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const HintLink = styled.a`
  color: #e1251b;
  text-decoration: none;
  cursor: pointer;
`;

export const EmailBox = styled.div`
  width: 100%;
  height: 52.6px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  background-color: #f1f1f1;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    height: auto;
    min-height: 52.6px;
  }
`;

export const EmailIcon = styled.div`
  flex: 0 0 auto;
  width: 31px;
  height: 30px;
  border-radius: 50%;
  background-color: #ee3841;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmailText = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #737377;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const BranchSelectWrap = styled.div`
  position: relative;
  width: 100%;
`;

type BranchTriggerProps = {
  hasValue: boolean;
};

export const BranchTrigger = styled.button<BranchTriggerProps>`
  width: 100%;
  height: 52.3px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 16px;
  border: none;
  border-radius: 10px;
  background-color: #f1f1f1;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => (props.hasValue ? "#494949" : "#bababa")};
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }

  & svg {
    flex: 0 0 auto;
    transition: transform 0.15s ease-in-out;
  }

  & > span {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    height: auto;
    min-height: 52.3px;
    gap: 8px;
    padding: 10px 16px;
    font-size: 16px;
  }
`;

export const BranchOptions = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 10;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  background-color: #f1f1f1;
  box-shadow: 1px 1px 4px 0 rgba(22, 22, 29, 0.3);
  max-height: 260px;
  overflow-y: auto;
`;

export const BranchOption = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;

  &:hover {
    background-color: #e2e2e2;
  }
`;

export const BranchOptionName = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #737377;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const BranchOptionCount = styled.span`
  flex: 0 0 auto;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #737377;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const SummaryBox = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 10px;
  background-color: #eeeeee;
`;

export const SummaryTitle = styled.p`
  margin: 0 0 10px;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #6e6e6e;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 18px;
  }
`;

export const SummaryStats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SummaryStat = styled.span`
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const AddressRow = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    gap: 12px;
  }
`;

export const AddressField = styled.input`
  width: 100%;
  flex: 1 1 0;
  min-width: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 10px;
  border: solid 1px #c4c4c4;
  border-radius: 10px;
  background-color: #eee;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: 300;
  color: #a2a2a5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    height: 44px;
    font-size: 16px;
  }
`;

export const AddressDetailLabel = styled.span`
  margin-top: -32px;
  font-size: 24px;
  font-weight: 600;
  color: #000000;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin-top: 0;
    font-size: 16px;
  }
`;

export const AddressDetailBox = styled.div`
  width: 100%;
  min-height: 158px;
  margin-top: -32px;
  box-sizing: border-box;
  padding: 10px 19px;
  border-radius: 10px;
  background-color: #f1f1f1;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: normal;
  line-height: normal;
  color: #737377;
  overflow-wrap: anywhere;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    min-height: 96px;
    margin-top: -8px;
    font-size: 16px;
  }
`;

export const SellerCodeRow = styled.div`
  width: 100%;
  height: 87px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 10px 10px 10px 30px;
  border-radius: 10px;
  background-color: #ffffff;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    height: auto;
    padding: 8px 8px 8px 16px;
  }
`;

export const SellerCodeViewRow = styled.div`
  width: 100%;
  height: 52.3px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-radius: 10px;
  background-color: #f1f1f1;
`;

export const SellerCodeViewLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
`;

export const SellerCodeViewText = styled.span`
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 24px;
  font-weight: normal;
  color: #737377;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const SellerCodeEditButton = styled.button`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0;
`;

export const SellerCodeError = styled.p`
  width: 100%;
  margin: 0;
  font-family: SegoeUI, "Open Sans", sans-serif;
  font-size: 14px;
  color: #e1251b;
`;

export const SellerCodeInput = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  font-size: 24px;
  color: #494949;

  &::placeholder {
    color: #737377;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 16px;
  }
`;

export const ValidateButton = styled.button`
  flex: 0 0 auto;
  width: 192px;
  height: 67px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 20px 40px;
  border: solid 1px #e1251b;
  border-radius: 5px;
  background-color: transparent;
  color: #e1251b;
  font-family: "Poppins", "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: auto;
    height: 48px;
    padding: 12px 20px;
    font-size: 16px;
  }
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    .return-link-container {
      width: auto !important;
      margin: 0;
    }

    .return-link {
      display: flex;
      align-items: center;
      font-size: 16px;
      white-space: nowrap;
    }
  }
`;

export const ContinueButton = styled(CartPaymentButton)`
  width: 287px;
  height: 67px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px 40px;
  border-radius: 5px;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: auto;
    flex: 0 1 200px;
    height: 48px;
    padding: 12px 24px;
    font-size: 16px;
  }
`;
